module.exports = __webpack_public_path__ + "img/stage6.10a46b58.png";